<form [formGroup]="form" autocomplete="off">

    <p-dialog showHeader="false" [(visible)]="display" [modal]="true" width="500" [baseZIndex]="10000"
              header="Editar Matrículas y Precintos" (onShow)="showDialogMaximized(dialDetail)" #dialDetail>

        <div class="animated fadeIn container-fluid">

            <div class="row">
                <div class="col-md-12">

                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a">
                            <div class="card-header-buscador">
                                <i class="fa fa-list"></i> <strong>{{editTitle}} Equipamiento</strong>
                            </div>
                        </a>
                        <div class="card-body-detalle">

                            <div class="row">
                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="inpDescripcion">Matrícula</label>
                                    <input formControlName="Matricula" name="Matricula" maxlength="50" title="" class="form-control" id="" type="text" value="">
                                </div>
                                <div class="form-group col-md-6">
                                    <label class="col-form-label" for="inpDescripcion">Precinto</label>
                                    <input formControlName="Precinto" name="Precinto" maxlength="50" title="" class="form-control" id="" type="text" value="">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <p-footer>
            <button pButton (click)="aceptDialog()" [disabled]="!form.valid || form.pristine" label="Aceptar" class="p-confirm-dialog-accept" icon="pi pi-check" title="Aceptar"></button>
            <button pButton (click)="cancelDialog()" label="Cancelar" class="p-confirm-dialog-reject" icon="pi pi-times" title="Cancelar"></button>
        </p-footer>

    </p-dialog>

</form>